import * as assert from 'assert';
import { IPublicUser, IUpdateUser } from '../_interfaces/IUser';
import { ApiService } from './ApiService';

export class UserService extends ApiService {
    protected basePath = 'users';

    public update(args: IUpdateUser): Promise<void> {
        let data: IUpdateUser | FormData = args;

        if (args.image_file) {
            data = this.formatFormData(args);
        }

        return this.putRequest(data);
    }

    public getAll(): Promise<Array<IPublicUser>> {
        return this.getRequest().then((response: Array<any>) => {
            if (Array.isArray(response)) {
                return this.assembleInstances(response);
            } else {
                assert(false, 'AbstractCRUDService - getAll : unexpected response from server');
            }

            return [] as Array<IPublicUser>;
        });
    }

    public getById(user_id: number): Promise<IPublicUser> {
        console.assert(user_id, 'Paramater is undefined');

        return this.getSubPath(user_id.toString()).then((response: object) => {
            return this.assembleSingleInstance(response);
        });
    }

    protected assembleInstances(response: Array<any>): Array<IPublicUser> {
        return response;
    }

    protected assembleSingleInstance(response: any): IPublicUser {
        return response;
    }

    private formatFormData(newRecord: IUpdateUser): FormData {
        const out = new FormData();

        if (newRecord.first_name) {
            out.append('first_name', newRecord.first_name);
        }
        if (newRecord.last_name) {
            out.append('last_name', newRecord.last_name);
        }
        if (newRecord.image_file) {
            out.append('image', newRecord.image_file);
        }

        return out;
    }
}



// WEBPACK FOOTER //
// ./src/_services/UserService.ts